import "./Slider.css";

function Slider({ value }) {
  return (
    // <input
    //   type="range"
    //   min="0"
    //   max="100"
    //   value={value}
    //   className="slider"
    //   id="staked-slider"
    //   readOnly
    // />
    <div className="slider">
      <div className="progress" style={{ width: `${value}%` }}></div>
    </div>
  );
}

export default Slider;
